if (!customElements.get('search-suggestions')) {
  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      const mainSearch = this.closest('main-search');
      if (mainSearch) {
        this.searchInput = mainSearch.querySelector('input[name="q"]');
      } else {
        this.searchInput = this.closest('form').querySelector('input[name="q"]');
      }
      if (this.searchInput) {
        this.searchInput.addEventListener('keyup', this.handleInputChange.bind(this));
        this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
      }
    }

    handleInputChange() {
      if (!this.searchInput) return;
      const valueToSearch = this.searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.length) {
        clearTimeout(this.searchTimeoutID);

        if (this.searchSuggestionsAbortController) {
          this.searchSuggestionsAbortController.abort();
          this.searchSuggestionsAbortController = null;
        }

        // Show placeholder for spacing when input is empty
        this.innerHTML = '<div class="search-suggestions"><span class="search-suggestions__placeholder">&nbsp;</span></div>';
      }

      this.oldSearchValue = valueToSearch;
    }

    fetchSuggestions(terms) {
      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort();
      }
      this.searchSuggestionsAbortController = new AbortController();

      fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(terms)}&section_id=search-suggestions`, {
        signal: this.searchSuggestionsAbortController.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.search-suggestions-wrapper');

          this.innerHTML = '';
          if (results && results.firstElementChild) {
            this.insertAdjacentElement('beforeend', results.firstElementChild);
          } else {
            // Show placeholder when no results
            const placeholder = document.createElement('div');
            placeholder.className = 'search-suggestions';
            placeholder.innerHTML = '<span class="search-suggestions__placeholder">&nbsp;</span>';
            this.insertAdjacentElement('beforeend', placeholder);
          }
        })
        .catch((error) => {
          if (error.code === 20) {
            return; // aborted
          }
          throw error;
        });
    }
  };

  window.customElements.define('search-suggestions', SearchSuggestions);
}
